import { usePersistedStore } from "@asurion-core/headless-chat-web";

import { useGuideStore } from "../store";

export function getRoomId(sessionId: string) {
    const { errorStateSessionId } = useGuideStore.getState().getGuideSession(sessionId);
    const { externalTicketIdMetadataMap: roomIdsBySession } = usePersistedStore.getState();
    return roomIdsBySession[`${errorStateSessionId || sessionId}`]?.simplrChatRoomId;
}
